import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=dcd1ce30&scoped=true"
import script from "./UsersPage.vue?vue&type=script&lang=ts"
export * from "./UsersPage.vue?vue&type=script&lang=ts"
import style0 from "./UsersPage.vue?vue&type=style&index=0&id=dcd1ce30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd1ce30",
  null
  
)

export default component.exports